import { render, staticRenderFns } from "./Products_FilterProducts.vue?vue&type=template&id=6da3b055&scoped=true&"
import script from "./Products_FilterProducts.vue?vue&type=script&lang=js&"
export * from "./Products_FilterProducts.vue?vue&type=script&lang=js&"
import style0 from "./Products_FilterProducts.vue?vue&type=style&index=0&id=6da3b055&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da3b055",
  null
  
)

export default component.exports